/* eslint-disable max-len */
import { ColorRecipeModel } from 'src/app/edit/models/color-recipe.model';
import { ScalarFresnelModel } from 'src/app/edit/models/scalar-fresnel.model';

// Colors
export const PaintPresetOriginal = new ColorRecipeModel({
  label: 'Original',
  tintColor: false,
  saturation: false,
  contrast: false,
  brightness: false,
  opacity: false,
});
export const PaintPresetBlack = new ColorRecipeModel({
  tintColor: [0, 0, 0],
  saturation: false,
  contrast: false,
  brightness: false,
  opacity: false,
});
export const PaintPresetRed = new ColorRecipeModel({
  tintColor: [1, 0, 0],
  saturation: false,
  contrast: false,
  brightness: false,
  opacity: false,
});
export const PaintPresetYellow = new ColorRecipeModel({
  tintColor: [1, 1, 0],
  saturation: false,
  contrast: false,
  brightness: false,
  opacity: false,
});
export const PaintPresetGreen = new ColorRecipeModel({
  tintColor: [0, 1, 0],
  saturation: false,
  contrast: false,
  brightness: false,
  opacity: false,
});
export const PaintPresetCyan = new ColorRecipeModel({
  tintColor: [0, 1, 1],
  saturation: false,
  contrast: false,
  brightness: false,
  opacity: false,
});
export const PaintPresetBlue = new ColorRecipeModel({
  tintColor: [0, 0, 1],
  saturation: false,
  contrast: false,
  brightness: false,
  opacity: false,
});
export const PaintPresetPink = new ColorRecipeModel({
  tintColor: [1, 0, 1],
  saturation: false,
  contrast: false,
  brightness: false,
  opacity: false,
});

// Effects
export const PaintPresetGrayscale = new ColorRecipeModel({
  label: 'Grayscale',
  tintColor: false,
  saturation: -100,
  contrast: false,
  brightness: false,
  opacity: false,
});
export const PaintPresetDesaturated = new ColorRecipeModel({
  label: 'Desaturated',
  tintColor: false,
  saturation: -50,
  contrast: false,
  brightness: false,
  opacity: false,
});
export const PaintPresetFade = new ColorRecipeModel({
  label: 'Fade',
  tintColor: [0, 0, 0],
  contrast: false,
  brightness: 55,
  saturation: -100,
  opacity: new ScalarFresnelModel({ edge: 1, center: 0, edgeBias: 0, centerBias: 1, power: 1 }),
});

// Tint Color Presets
export const PaintTintPresets = [
  PaintPresetOriginal,
  PaintPresetBlack,
  PaintPresetRed,
  PaintPresetYellow,
  PaintPresetGreen,
  PaintPresetCyan,
  PaintPresetBlue,
  PaintPresetPink,
];

export const PaintEffectPresets = [PaintPresetGrayscale, PaintPresetDesaturated, PaintPresetFade];

// Complete Paint Preset Set
export const PaintPresets = [
  PaintPresetOriginal,
  ...PaintTintPresets,
  PaintPresetGrayscale,
  PaintPresetDesaturated,
  PaintPresetFade,
];
